import {
	ChangeDetectionStrategy,
	Component,
	ContentChild,
	input,
	TemplateRef,
} from '@angular/core';
import {
	FeaturedClearingVisitWebsite,
	FeaturedPostgraduate,
	FeaturedUndergraduate,
} from '@uc/web/shared/data-models';
import { EntryRequirements } from '../../models/course.models';
import { CommonModule } from '@angular/common';
import { ArrowDownSvgComponent, ArrowUpSvgComponent } from '@uc/shared/svg';
import { ToggleFaqDirective } from '@uc/utilities';

@Component({
	selector: 'uc-entry-requirements',
	templateUrl: './entry-requirements.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		ArrowDownSvgComponent,
		CommonModule,
		ArrowUpSvgComponent,
		ToggleFaqDirective,
	],
})
export class EntryRequirementsComponent {
	externalUrl = input.required<string | undefined>();
	entryRequirements = input.required<EntryRequirements[]>();
	isFeatured = input.required<
		FeaturedUndergraduate | FeaturedPostgraduate | FeaturedClearingVisitWebsite
	>();

	@ContentChild('visitWebsiteBtn') visitWebsiteBtnRef!: TemplateRef<any>;
}
